import { getSiteKey } from "../firebaseConfig";

export interface CheckoutRequest {
    amount: number;
    currency: string;
    cancelUrl: string;
    successUrl: string;
    failureUrl: string;
    orderId: string;
    orderNumber: string;
    origin: string;
}

export interface Metadata {
    [key: string]: string;
}

export interface CheckoutResponse {
    id: string;
    redirectUrl: string;
}

const checkOut =async (data: CheckoutRequest, endPoint: string)=>{
    const response = await fetch(`${process.env.REACT_APP_MESSAGE_API_HOST}/${endPoint}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "x-client-key": getSiteKey()
            },
            body: JSON.stringify(data)
        });

        if (!response.ok) {
            const errorData = await response.json();
            console.error(`Error calling checkout. (Status code: ${response.status})`, errorData)
            throw new Error(errorData.message || "Failed call checkout");
        }

        return response;
}

export const PaymentGateway = {
    YocoCheckout: async (data: CheckoutRequest): Promise<Response> => checkOut(data,"yocoCheckout"),
    YocoRegister: async (secret: string, idToken: string): Promise<Response> => {
        const response = await fetch(`${process.env.REACT_APP_MESSAGE_API_HOST}/yocoRegister`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "x-client-key": getSiteKey(),
                Authorization: `Bearer ${idToken}`
            },
            body: JSON.stringify({ secret })
        });

        if (!response.ok) {
            const errorData = await response.json();
            console.error(`Error calling register Yoco. (Status code: ${response.status})`, errorData)
            throw new Error(errorData.message || "Failed call yocoRegister");
        }

        return response;
    },
    ZapperCheckout: async (data: CheckoutRequest): Promise<Response> => checkOut(data,"zapperCheckout"),
    ZapperRegister: async (merchantId: string, merchantSiteId: string, merchantSiteApiKey: string, apiKey: string, idToken: string): Promise<Response> => {
        const response = await fetch(`${process.env.REACT_APP_MESSAGE_API_HOST}/zapperRegister`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "x-client-key": getSiteKey(),
                Authorization: `Bearer ${idToken}`
            },
            body: JSON.stringify({ merchantId, siteId: merchantSiteId, apiKey, merchantSiteApiKey })
        });

        if (!response.ok) {
            const errorData = await response.json();
            console.error(`Error calling register Zapper. (Status code: ${response.status})`, errorData);
            throw new Error(errorData.message || "Failed to call zapperRegister");
        }

        return response;
    },
    SnapScanCheckout: async (data: CheckoutRequest): Promise<Response> => checkOut(data,"snapscanCheckout"),
    SnapScanRegister: async (snapCode: string, apiKey: string, webhookAuthKey: string, idToken: string): Promise<Response> => {
        const response = await fetch(`${process.env.REACT_APP_MESSAGE_API_HOST}/snapscanRegister`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "x-client-key": getSiteKey(),
                Authorization: `Bearer ${idToken}`
            },
            body: JSON.stringify({ snapCode, apiKey, webhookAuthKey })
        });

        if (!response.ok) {
            const errorData = await response.json();
            console.error(`Error calling register SnapScan. (Status code: ${response.status})`, errorData);
            throw new Error(errorData.message || "Failed to call snapscanRegister");
        }

        return response;
    }
};